function initTileCalculator() {
  // Get data attributes from hidden element (liquid variables workaround)
  const dataEl = document.getElementById('tile-calculator-data');
  if (!dataEl) return;

  const tileWidth = parseInt(dataEl.dataset.tileWidth);
  const tileLength = parseInt(dataEl.dataset.tileLength);
  const tilesPerBox = parseInt(dataEl.dataset.tilesPerBox);
  const pricePerBoxInPence = parseInt(dataEl.dataset.pricePerBox);

  // Calculate tile area in m²
  const tileArea = (tileWidth / 1000) * (tileLength / 1000);
  const areaPerBox = tilesPerBox * tileArea;

  // Get elements
  const areaInput = document.getElementById('area');
  const boxesInput = document.getElementById('numBoxes');
  const wasteCheckbox = document.getElementById('wasteCheckbox');
  const boxesCountSpan = document.getElementById('boxesCount');
  const boxesPluralSpan = document.getElementById('boxesPlural');
  const areaCoveredSpan = document.getElementById('areaCovered');
  const finalPriceSpan = document.getElementById('finalPrice');

  areaInput.value = roundDownToDecimalPlaces(areaPerBox, 2);
  boxesInput.value = 1;

  recalculate();

  // Event listeners for input changes
  areaInput.addEventListener('input', calculateBoxesFromArea);
  boxesInput.addEventListener('input', calculateAreaFromBoxes);
  wasteCheckbox.addEventListener('change', recalculate);

  const inputsToDisableEnter = document.querySelectorAll('input[id="numBoxes"], input[id="area"]');
  inputsToDisableEnter.forEach((input) => {
    input.addEventListener('keypress', (evt) => {
      if (evt.key === 'Enter') evt.preventDefault();
    });
  });

  function roundDownToDecimalPlaces(num, decimalPlaces) {
    const factor = Math.pow(10, decimalPlaces); // Adjust the scale
    const roundedDown = Math.floor(num * factor) / factor; // Floor and scale back
    return roundedDown.toFixed(decimalPlaces); // Ensures fixed decimal places
  }

  function calculateBoxesFromArea() {
    const area = parseFloat(areaInput.value);
    const wasteFactor = wasteCheckbox.checked ? 1.1 : 1;

    if (isNaN(area) || area <= 0) {
      boxesInput.value = '';
      updateResult(0, 0); // Reset results
      return;
    }

    // Calculate tiles/boxes needed including waste, if checked
    const tilesNeeded = Math.ceil((area / tileArea) * wasteFactor);
    const boxesNeeded = Math.ceil(tilesNeeded / tilesPerBox);
    boxesInput.value = boxesNeeded;

    // Update the area covered based on the number of boxes
    const updatedArea = boxesNeeded * areaPerBox;
    updateResult(boxesNeeded, updatedArea);
  }

  function calculateAreaFromBoxes() {
    const numBoxes = parseInt(boxesInput.value);

    if (isNaN(numBoxes) || numBoxes <= 0) {
      areaInput.value = '';
      updateResult(0, 0); // Reset results
      return;
    }

    // Calculate total tiles from the number of boxes
    const totalTiles = numBoxes * tilesPerBox;
    const totalArea = totalTiles * tileArea;
    areaInput.value = roundDownToDecimalPlaces(totalArea, 2);

    updateResult(numBoxes, totalArea);
  }

  function recalculate() {
    if (areaInput.value) {
      calculateBoxesFromArea();
    } else if (boxesInput.value) {
      calculateAreaFromBoxes();
    }
  }

  function updateResult(boxes, area) {
    const totalPriceInPence = boxes * pricePerBoxInPence;
    const totalPriceInPounds = (totalPriceInPence / 100).toFixed(2);

    // Update spans with dynamic values
    boxesCountSpan.textContent = boxes || 0;
    boxesPluralSpan.textContent = tilesPerBox > 1 ? (boxes === 1 ? 'box' : 'boxes') : boxes === 1 ? 'tile' : 'tiles';
    areaCoveredSpan.textContent = area > 0 ? roundDownToDecimalPlaces(area, 2) : '0.00';
    finalPriceSpan.textContent = boxes > 0 ? `£${totalPriceInPounds}` : '£0.00';
  }
}

// Variable to store area value between variant changes
let lastAreaValue = '';

// Listen for focus/blur/input to keep the latest value
document.addEventListener('input', (e) => {
  if (e.target && e.target.id === 'area') {
    lastAreaValue = e.target.value;
  }
});
document.addEventListener('change', (e) => {
  if (e.target && e.target.id === 'area') {
    lastAreaValue = e.target.value;
  }
});

// Run on initial page load
document.addEventListener('DOMContentLoaded', initTileCalculator);

// Run on variant change, restoring area input if present
document.addEventListener('variant:change', () => {
  initTileCalculator();

  // Restore area input value and trigger calculation if user had entered a value
  const areaInput = document.getElementById('area');
  if (areaInput && lastAreaValue) {
    areaInput.value = lastAreaValue;
    const event = new Event('input', { bubbles: true });
    areaInput.dispatchEvent(event);
  }
});
